export default __webpack_public_path__ + "media/images/logos/citb-logo-4c92a58be00fa8da603e778a58a125d9.png";